import React from 'react';
import classNames from 'classnames';
import { POST_TEXT_COLOR } from '../../constants';
import { getSiteColor, setColorOpacity } from '../../services';
import { getBannerTheme } from '../../services/paywall-theme';
import styles from './paywall-banner.scss';
const none = () => ({});
const PaywallBanner = ({ viewer: RichContentViewer, banner, onSubscribe, className, appSettings, section, }) => {
    const theme = getBannerTheme({ appSettings, section });
    const textColor = getSiteColor(appSettings, {
        wixParam: POST_TEXT_COLOR,
        presetFallback: 'color-5',
        colorFallback: '#000',
    });
    const borderColor = setColorOpacity({ color: textColor, alpha: 0.2 });
    return (React.createElement("div", { className: classNames(styles.container, className), style: { borderColor } },
        React.createElement(RichContentViewer, { theme: theme, initialRawState: banner, parentClass: className, onButtonClick: onSubscribe, getStyle: none })));
};
export default PaywallBanner;
//# sourceMappingURL=paywall-banner.js.map